import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "./Loading";
import checked from "../../src/assets/checked.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AutoComplete } from "antd";
import { getInventoryallproducts } from "../API  Functions/InventoryFunctions";
import LoaderComponent from "../Loader";
import BarcodeScanner from "react-barcode-reader";
const ReplaceItemModal = ({
  isOpen,
  onClose,
  product,
  replaceItem,
  allProducts,
}) => {
  const inputRef = useRef(null); // ⬅️ Ref for input
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dropdownData, setDropdownData] = useState([]);
  const [inputValue, setInputValue] = useState("");

    useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 100); // delay ensures input is rendered
    }
  }, [isOpen]);


  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 50,
    },
    container: {
      width: "50%",
      padding: "30px",
      paddingBottom:"60px",
      borderRadius: "18px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 50,
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 5,
    },
    title: {
      fontSize: "20px",
      fontWeight: "bold",
      textAlign: "center",
      marginBottom: "10px",
    },
    cancelIcon: {
      cursor: "pointer",
    },
  };

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );

  const GetReplacingProduct = async (barcode, text) => {
    try {
      setLoading(true);
      const data = await getInventoryallproducts(
        user_id,
        company_id, // store_id
        false, // categoryId
        text, // productName
        20, // limit
        0, // offset
        false, // is_discounted
        false, // is_loose
        barcode,
      );
      // setScanned(false);
      console.log("data>>", data?.result);
      if (
        typeof data?.result === "string" &&
        data?.result?.includes("401 UNAUTHORIZED")
      ) {
        // setSessionExpired(true);
      } else {
        if (!data?.error && data.result[0]?.status_code == 200) {
          if (text?.length > 0) {
            setDropdownData(data.result[0].response);
          } else if(barcode?.length > 0) {
            checkProduct(data.result[0].response[0]);
          }
        } else {
          setDropdownData([]);
          // setDropdownDataBarcode([]);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const checkProduct = (prod) => {
    console.log("prod==>",prod);
 
    // Check if prod already exists in allProducts
    const alreadyExists = allProducts.some(
      (p) => p.product_id === prod?.quant_id
    );

    if (product?.product_id === prod?.quant_id) {
      toast.error(t("The same product cannot be replaced."));
    } else if (alreadyExists) {
      toast.error(t("This product already exists."));
    } else {
      replaceItem(prod, product);
    }
  };

  return (
    <>
      {/* {loading && <LoadingSpinner />} */}

      {isOpen && (
        <>
          <div
            className="backdrop-blur"
            style={styles.overlay}
            onClick={onClose}
          ></div>
          <div style={styles.container}>
            <div style={styles.header}>
              <p style={styles.title}>{t("Replace Item")}</p>
              <CloseOutlined style={styles.cancelIcon} onClick={onClose} />
            </div>
            <AutoComplete
              value={inputValue}
              options={dropdownData.map((option) => ({
                value: option.quant_id,
                label: option.product_name,
              }))}
              onSearch={(value) => {
                setInputValue(value)

                GetReplacingProduct("", value);
              }}
              onSelect={(value, item) => {
                console.log("value==>",value);
                console.log("item==>",item);
                // setInputValue(item?.label)
                
                const selectedProduct = dropdownData?.find(
                  (item) => item.quant_id === value
                );
                checkProduct(selectedProduct);
              }}
              style={{ width: "100%", height: "60px" }}
              placeholder={t("search_product")}
              // readOnly={isProductSelected}
              // disabled={isAddBarcodeModalOpen}
              ref={inputRef}
            />
           
              <div className="ms-4 flex self-center mt-5 w-full items-center justify-center">
                 {loading ?
                <LoaderComponent />: <>
                <div className="h-5"></div>
                </>}
              </div>
           <BarcodeScanner
            onScan={(data) => {
              console.log("BArcode Data", data);

              GetReplacingProduct(data, ''); // Set the scanned barcode value
            }}
            onError={(err) => {
              console.error(err);
            }}
            facingMode="environment"
            className="absolute inset-y-0 right-0 me-4 pointer-events-none cursor-pointer z-10"
          />
          </div>
        </>
      )}
    </>
  );
};

export default ReplaceItemModal;
